export default "__VITE_ASSET__KMJY1zHu__"